import { onSubmitForm, onClickWhatsapp } from './clickEvents.js'
import { isEmailInvalid, isNameInvalid, isPhoneNumberInvalid, isFieldInvalid, isCaptchaInvalid, displayErrorSpan, toggleSubmitBtn, areFormFieldsValid } from './utils/validation.js'
import { showModalHandler, hideModalHandler } from './domStructure/modalHandler.js'
import { createBannerComponent } from './domStructure/generics.js'
import { createCopyrightAndCreatorSection } from './domStructure/footer.js'
import { CaptchaManager } from './utils/captcha.js'
// import { resizeWindowHandler } from './utils/windowResize'

const postBtn = document.querySelector('#email-quote')
const wrapper = document.querySelector('#request-form')
let inputs = []
const parentReqModal = "reqQuoteModal"
const reqQuoteModalDivId = "reqQuoteModalStart"
const jsonFile = `${fantastic_windows_vars.api_url}/assets/JSON/upvcJson.json`
let modalMessage = ``
const captchaManager = new CaptchaManager()

window.onload=function() {
    createBannerComponent("Quote", "h1", document.querySelector('#bannerId'))
    document.getElementById("request-form").reset()
    toggleSubmitBtn(postBtn, true)
    
    // Initialize CAPTCHA
    captchaManager.initializeCaptcha('request-form')
    
    // Then get all inputs including CAPTCHA
    inputs = [...wrapper.querySelectorAll('.input')]

    const copyrightAndCreatorsJson = ""
    const copyrightAndCreatorSection = document.querySelector('#copyright-and-creators-id')
    createCopyrightAndCreatorSection(copyrightAndCreatorSection, copyrightAndCreatorsJson)
}

document.querySelector('#request-form').addEventListener('input', function() {
    let isInvalid = inputs.some(input => !areFormFieldsValid(input.id, 'request-form'))
    toggleSubmitBtn(postBtn, isInvalid)
})

document.querySelector('#email-quote').addEventListener('click', async (e) => {
    // Validate CAPTCHA before submitting
    if (!captchaManager.validateCaptcha('request-form')) {
        return false
    }
    
    modalMessage = await onSubmitForm('request-form')
    $('#reqQuoteModal').modal('show')
})

document.querySelector('#whatsapp-icon').addEventListener('click', (e) => {
    onClickWhatsapp()
})

document.querySelector('#firstName').addEventListener('keyup', (e) => {
    let error = isNameInvalid( $("#firstName").val()  )
    displayErrorSpan (error,  $("#fnameError") )        // Show error `span` when firstName is invalid
})

document.querySelector('#lastName').addEventListener('keyup', (e) => {
    let error = isNameInvalid( $("#lastName").val()  )
    displayErrorSpan (error,  $("#lnameError") )        // Show error `span` when lastName is invalid
})

document.querySelector('#country').addEventListener('keyup', (e) => {
    let error = isFieldInvalid( $("#country").val()  )
    displayErrorSpan (error,  $("#countryError") )        // Show error `span` when country is invalid
})

document.querySelector('#city').addEventListener('keyup', (e) => {
    let error = isFieldInvalid( $("#city").val()  )
    displayErrorSpan (error,  $("#cityError") )        // Show error `span` when city is invalid
})

document.querySelector('#state').addEventListener('keyup', (e) => {
    let error = isFieldInvalid( $("#state").val()  )
    displayErrorSpan (error,  $("#stateError") )        // Show error `span` when state is invalid
})

document.querySelector('#address').addEventListener('keyup', (e) => {
    let error = isFieldInvalid( $("#address").val()  )
    displayErrorSpan (error,  $("#addressError") )        // Show error `span` when address is invalid
})

document.querySelector('#email').addEventListener('keyup', (e) => {
    let error = isEmailInvalid( $("#email").val()  )
    displayErrorSpan (error,  $("#emailError") )        // Show error `span` when email is invalid
})

document.querySelector('#phone').addEventListener('keyup', (e) => {
    let error = isPhoneNumberInvalid( $("#phone").val()  )
    displayErrorSpan (error,  $("#numberError") )        // Show error `span` when phone is invalid
})


$(`#${parentReqModal}`).on('show.bs.modal', function() {
    showModalHandler(parentReqModal, reqQuoteModalDivId, jsonFile, {heading: "Message Response", message: modalMessage})
})

$(`#${parentReqModal}`).on('hide.bs.modal', hideModalHandler(parentReqModal, reqQuoteModalDivId))

const $dropdown = $(".dropdown")
const $dropdownToggle = $(".dropdown-toggle")
const $dropdownMenu = $(".dropdown-menu")
const showClass = "show"
// $(window).on("load resize", function() {
//     resizeWindowHandler(this, $(this), $dropdown, $dropdownToggle, $dropdownMenu, showClass)
// })
$(window).on("load resize", function() {
    if (this.matchMedia("(min-width: 768px)").matches) {
        $dropdown.hover(
            function() {
                const $this = $(this);
                $this.addClass(showClass);
                $this.find($dropdownToggle).attr("aria-expanded", "true");
                $this.find($dropdownMenu).addClass(showClass);
            },
            function() {
                const $this = $(this);
                $this.removeClass(showClass);
                $this.find($dropdownToggle).attr("aria-expanded", "false");
                $this.find($dropdownMenu).removeClass(showClass);
            }
        )
    } else {
        $dropdown.off("mouseenter mouseleave");
    }
})


